<template>
    <div :class="`DshInput ycFormItem control-${mode}`">
        <Input
            v-if="canEdit && propsObj.canEdit!=false || propsObj._type=='textarea'"
            :class="{
                'DshInput-readonly': $isReadonly(canEdit, propsObj),
                'DshInput-disabled': $isDisabled(canEdit, propsObj)
            }"
            v-model="value[propsObj._key]"
            :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
            :type="['text', 'password', 'textarea', 'url', 'email', 'number', 'tel'].includes(propsObj._type) ? propsObj._type : undefined"
            :disabled="!finalCanEdit"
            :clearable="finalCanEdit && clearable"
            :size="propsObj._size"
            :rows="propsObj._rows"
            :search="propsObj._search"
            :autosize="textareaAutosize"
            @on-search="onSearch"
            @on-focus="onFocus"
            @on-change="onChange"
            @on-blur="onBlur"
            @on-clear="onClear"
        >
            <span v-if="propsObj._prepend" slot="prepend">{{ propsObj._prepend }}</span>
            <span v-if="propsObj._append" slot="append">{{ propsObj._append }}</span>
        </Input>
        <Ctooltip
            v-else
            placement="top"
            :transfer="true"
            maxWidth="200"
            :content="format()"
            :class="{
                'DshInput-notAllowed':true,
                'DshInput-ellipsis-readonly': $isReadonly(canEdit, propsObj),
                'DshInput-ellipsis-disabled': $isDisabled(canEdit, propsObj)
            }"
        >
            <span class="dsh-ellipsis">
                {{ format() }}
            </span>
        </Ctooltip>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshInput",
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                changeStatus: false,
                format: function () {
                    return this.value[this.propsObj._key] || "";
                }
            };
        },
        computed: {
            textareaAutosize () {
                return this.propsObj._autosize || { minRows: 2 };
            }
        },
        created () {},
        methods: {
            onSearch (...params) {
                this.$emit("search", ...params);
            },
            // 无参数
            onFocus () {
                this.changeStatus = false;
            },
            // 无参数
            onBlur () {
                if (this.changeStatus === true) {
                    this.change();
                }
            },
            // 参数event
            onChange (event) {
                this.changeStatus = true;
            },
            onClear () {
                this.change();
            }
        }
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshInput.vue